__turbopack_context__.v({
  "className": "ShFT-W_className",
  "variable": "ShFT-W_variable",
});
